import styled from 'styled-components';

import { Button } from '@components/button';
import { EmptyStateExtraSmall } from '@components/empty-state/empty-state';
import { IconFormIndicatorWarning } from '@components/icons/form-indicator-warning';
import { SizedRelativeSpinner } from '@components/loading-spinner';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

type LoadFailedPanelProps = {
  title: string;
  description: string;
  onRetry: () => void;
  isRetrying: boolean;
};

export const LoadFailedPanel = ({
  title,
  description,
  onRetry,
  isRetrying,
}: LoadFailedPanelProps) => {
  const { t } = useScopedTranslate(locale);
  return (
    <div role="status" aria-live="polite">
      <Stack space={3} align="flex-start">
        <EmptyStateExtraSmall
          iconComponent={IconFormIndicatorWarning}
          title={title}
          description={description}
        />
        <Stack orientation="horizontal" space={3} align="center">
          <Button variant="secondary" text={t('retry')} onClick={onRetry} disabled={isRetrying} />
          {isRetrying && <RetryingIndicator />}
        </Stack>
      </Stack>
    </div>
  );
};

export const RetryingIndicator = () => {
  const { t } = useScopedTranslate(locale);
  return (
    <>
      <PanelSpinner size={16} $skipMargin $borderWidth={2} />
      <Text text={t('retrying')} font="regular12" color="textHelper" />
    </>
  );
};

const PanelSpinner = styled(SizedRelativeSpinner)({
  '&&': {
    flexShrink: 0,
  },
});

const locale = {
  en: {
    retry: 'Try again',
    retrying: 'Retrying…',
  },
};
